import { showSnackbar } from "src/store/reducers/navigation/navigationSlice";
import { AppDispatch } from "src/store/rootStore";
import { ApiError, ApiResponse } from "../models";

export const handleApiError = (dispatch: AppDispatch, error: ApiError) => {
  console.log("api error", error);
  const errorMessage = Array.isArray(error?.data?.message)
    ? error?.data?.message?.join(", ")
    : error?.data?.message || "Something went wrong";
  dispatch(
    showSnackbar({
      open: true,
      message: errorMessage,
      type: "error",
    }),
  );
};

export const handleApiResponse = (
  dispatch: AppDispatch,
  response: ApiResponse<void>,
) => {
  const message = Array.isArray(response?.message)
    ? response?.message?.join(", ")
    : response?.message || "Success";
  dispatch(
    showSnackbar({
      open: true,
      message,
      type: "success",
    }),
  );
};
